function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
//Limitless imports
import ForgotPasswordForm from "./ForgotPasswordForm";
import PortalSignInForm from "./PortalSignInForm";
import RegistrationCodeForm from "./RegistrationCodeForm";
import { useTranslation, useAppConfig } from "@limitless/common/hooks";
import { useSignInContext } from "../../../../expert";
const useStyles = makeStyles(() => ({
  loginFormRoot: {
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    width: 325
  }
}));
const LoginForm = ({
  location,
  ...rest
}) => {
  const [formState, setFormState] = React.useState({
    passwordResetFlow: false,
    verificationCodeSent: false,
    signInInfoMessage: "",
    hasBeenToResetFlow: false
  });
  const classes = useStyles();
  const {
    t
  } = useTranslation();
  const {
    getContactUsUrl
  } = useAppConfig();
  const {
    clearErrors,
    loading
  } = useSignInContext();
  const togglePasswordResetFlow = () => {
    setFormState({
      ...formState,
      passwordResetFlow: !formState.passwordResetFlow,
      hasBeenToResetFlow: true
    });
    clearErrors();
  };
  const handlePasswordResetComplete = () => {
    setFormState({
      ...formState,
      passwordResetFlow: false,
      signInInfoMessage: "Password successfully reset"
    });
  };
  const handleContactUsClick = () => {
    const navigationPath = "/contact-us";
    const url = getContactUsUrl(navigationPath);
    if (url === navigationPath) {
      rest.history.push(url);
    } else {
      window.open(url, "_blank");
    }
  };
  const renderPasswordResetForm = () => {
    const {
      verificationCodeSent
    } = formState;
    if (verificationCodeSent) {
      return /*#__PURE__*/React.createElement(RegistrationCodeForm, {
        onPasswordResetComplete: handlePasswordResetComplete
      });
    }
    return /*#__PURE__*/React.createElement(ForgotPasswordForm, {
      onVerificationCodeSent: () => setFormState({
        ...formState,
        verificationCodeSent: true
      })
    });
  };
  const {
    passwordResetFlow,
    signInInfoMessage,
    hasBeenToResetFlow
  } = formState;
  let redirectMessage = "";
  if (location.state && location.state.redirectMessage) {
    redirectMessage = location.state.redirectMessage;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: classes.loginFormRoot
  }, !passwordResetFlow && /*#__PURE__*/React.createElement(Typography, {
    variant: "h2",
    color: "textPrimary"
  }, "Sign In"), passwordResetFlow ? renderPasswordResetForm() : /*#__PURE__*/React.createElement(PortalSignInForm, _extends({
    infoMessage: signInInfoMessage,
    redirectMessage: redirectMessage,
    isInitialRender: !hasBeenToResetFlow
  }, rest)), rest.isManagerPortal === false && !passwordResetFlow ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    color: "textPrimary",
    style: {
      textAlign: "center"
    }
  }, t("Having trouble logging in?")), /*#__PURE__*/React.createElement(Grid, {
    style: {
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    color: "primary",
    style: {
      cursor: "pointer"
    },
    onClick: togglePasswordResetFlow
  }, t("Reset your password")), /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    color: "textPrimary",
    style: {
      paddingLeft: 2
    }
  }, t("or")), /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    color: "primary",
    style: {
      paddingLeft: 2,
      cursor: "pointer"
    },
    onClick: handleContactUsClick
  }, t("Contact Us")))) : /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    className: classes.forgotText,
    onClick: togglePasswordResetFlow,
    id: passwordResetFlow ? "backToSignInButton" : "forgotPasswordButton",
    disabled: loading
  }, /*#__PURE__*/React.createElement(Typography, {
    color: "textPrimary"
  }, passwordResetFlow ? t("Back to Sign In") : t("Forgot password?"))));
};
export default withRouter(LoginForm);
LoginForm.propTypes = {
  location: PropTypes.object.isRequired
};